import { useOrganizationsPageConfig } from './useAdminPanelPageConfig';

export function useOrganizationsEnabled(): { enabled: boolean; isLoading: boolean } {
  const { pageConfig, isLoading } = useOrganizationsPageConfig();
  return { enabled: pageConfig?.enableOrganizations ?? false, isLoading };
}
